module.exports = __webpack_public_path__ + "img/map-seminole.f1376b2b.png";